import React from 'react';
import PropTypes from 'prop-types';
import iconColorsMap from './colors';

const Tv = ({ fill, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    {...props}
  >
    <path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z" />
  </svg>
);
Tv.propTypes = { fill: PropTypes.string };
Tv.defaultProps = { fill: iconColorsMap.mainicon };

export default Tv;
